// import { useGoogleAnalytics } from "../../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { MapIcon } from "shared-components/Components/CustomIcons/MapIcon/web";
import { Button } from "shared-components/Components/Buttons/web";

export const ButtonMapToggle = ({ map, setMap }) => {
	const { changeFilters } = useFilters();
	// const GA = useGoogleAnalytics();

	return (
		<Button type="secondary"
			onClick={() => {
				let showMap = !map;
				// GA.Event({
				// 	category: "user_event",
				// 	action: "search_visualization_mode",
				// 	label: showMap ? "map" : "list",
				// });
				if (!showMap) changeFilters({ map_bounds: null, mapView: false, map_polygon: null });
				setMap(showMap);
			}}>
			<MapIcon />
			{map ? "Ver Listado" : "Ver Mapa"}
		</Button>
	);
};

